import {
	AfterViewInit,
	Component,
	Inject,
	OnInit,
	ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import * as cloneDeep from "lodash/cloneDeep";
import { ToastrService } from "ngx-toastr";
import { IBaseModel } from "src/app/models/base.model";
import { IProcedimentoAuditoriaModel } from "src/app/models/procedimento-auditoria.model";
import { IQuestaoConstatacaoModel } from "src/app/models/questao-constatacao.model";
import { IMatrizPlanejamentoModel } from "src/app/models/matriz-planejamento.model";
import { IQuestaoProcedimentoAuditoriaModel } from "src/app/models/questao-procedimento-auditoria.model";
import { ISubtipoAuditoriaMatrizPlanejamentoModel } from "src/app/models/subtipo-auditoria-matriz-planejamento.model";
import { ISubtipoAuditoriaModel } from "src/app/models/subtipo-auditoria.model";
import { IQuestaoModel } from "src/app/models/questao.model";
import { IProcedimentoTecnicaAuditoriaModel } from "src/app/models/procedimento-tecnica-auditoria.model";
import { ITecnicaAuditoriaModel } from "src/app/models/tecnica-auditoria.model";
import { IMatrizPlanejamentoQuestaoModel } from "src/app/models/matriz-planejamento-questao.model";
import { ProcedimentoAuditoriaService } from "src/app/services/procedimento-auditoria.service";
import { TecnicaAuditoriaService } from "src/app/services/tecnica-auditoria.service";
import { BaseFormComponent } from "../../shared/components/base-form/base-form.component";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import Swal from "sweetalert2";

@Component({
	selector: "app-procedimento-auditoria-form",
	templateUrl: "./procedimento-auditoria-form.component.html",
	styleUrls: ["./procedimento-auditoria-form.component.scss"],
})
export class ProcedimentoAuditoriaFormComponent
	extends BaseFormComponent
	implements OnInit, AfterViewInit
{
	@ViewChild("maxLengthEditor") private angularEditor: any;
	public model: IProcedimentoAuditoriaModel =
		{} as IProcedimentoAuditoriaModel;
	public modelMatrizPlanejamento: IMatrizPlanejamentoModel =
		{} as IMatrizPlanejamentoModel;
	public modelProcedimentoTecnicaAuditoria: IProcedimentoTecnicaAuditoriaModel =
		{} as IProcedimentoTecnicaAuditoriaModel;
	public listaTecnicas: ITecnicaAuditoriaModel[] = [];
	public modelSubtipoAuditoria: ISubtipoAuditoriaModel =
		{} as ISubtipoAuditoriaModel;
	public tecnicaAuditoriaDataSource =
		new MatTableDataSource<IProcedimentoTecnicaAuditoriaModel>([]);
	public listaConstatacao = new MatTableDataSource<IQuestaoConstatacaoModel>(
		[]
	);
	public listaProcedimentoAuditoria =
		new MatTableDataSource<IQuestaoProcedimentoAuditoriaModel>([]);
	public listaQuestao =
		new MatTableDataSource<IMatrizPlanejamentoQuestaoModel>([]);
	public listaMatrizPlanejamento =
		new MatTableDataSource<ISubtipoAuditoriaMatrizPlanejamentoModel>([]);
	public salvar: boolean;

	public rotaPrefixoSubtipoAuditoria = undefined;
	public rotaPrefixoMatrizPlanejamento = undefined;
	public semDados = true;
	public modelQuestao: IQuestaoModel = {} as IQuestaoModel;

	public isModal: boolean = false;

	public form = new FormGroup({
		nome: new FormControl("", Validators.required),
		fonteInformacao: new FormControl("", Validators.required),
		detalhamentoProcedimento: new FormControl("", Validators.required),
	});

	constructor(
		route: ActivatedRoute,
		toastr: ToastrService,
		router: Router,
		localeService: BsLocaleService,
		private procedimentoAuditoriaService: ProcedimentoAuditoriaService,
		private tecnicaAuditoriaService: TecnicaAuditoriaService,
		public matDialog: MatDialog,
		public dialogRef: MatDialogRef<ProcedimentoAuditoriaFormComponent>,
		@Inject(MAT_DIALOG_DATA) public dados: any
	) {
		super(route, toastr, router, localeService, matDialog);

		if (dados?.isModal) this.isModal = dados?.isModal;
		// Em modo modal (cadastro rápido via questão) o MAT_DIALOG_DATA contém
		// { isModal, state, model, ... } — não há id de procedimento aqui.
		// Mantém novoRegistro=true (herdado do BaseForm, sem param de rota).
		// Suporta edição via modal somente se um id explícito for informado.
		const modalId = dados?.procedimentoAuditoriaId ?? dados?.model?.procedimentoAuditoriaId;
		if (this.isModal && modalId) {
			this.id = modalId;
			this.novoRegistro = false;
		}
	}

	config: AngularEditorConfig = {
		editable: !this.visualizar,
		spellcheck: true,
		sanitize: false,
		height: "15rem",
		minHeight: "5rem",
		placeholder: "",
		translate: "yes",
		defaultParagraphSeparator: "p",
		defaultFontName: "Arial",
		toolbarHiddenButtons: [],
		customClasses: [
			{
				name: "quote",
				class: "quote",
			},
			{
				name: "redText",
				class: "redText",
			},
			{
				name: "titleText",
				class: "titleText",
				tag: "h1",
			},
		],
	};

	// async ngOnInit() {
	// 	this.state();
	// 	try {
	// 		if (!this.novoRegistro && this.id) {
	// 			const res = await this.procedimentoAuditoriaService.obterPorId(
	// 				this.id
	// 			);
	// 			if (res.sucesso) {
	// 				this.model = res.dados;
	//
	// 				this.tecnicaAuditoriaDataSource =
	// 					new MatTableDataSource<IProcedimentoTecnicaAuditoriaModel>(
	// 						this.model.procedimentoTecnicaAuditoria
	// 					);
	// 				this.tecnicaAuditoriaDataSource._updateChangeSubscription();
	// 				this.semDados =
	// 					this.tecnicaAuditoriaDataSource.filteredData.length ===
	// 					0;
	// 			} else {
	// 				Swal.fire({
	// 					toast: true,
	// 					position: "top-end",
	// 					icon: "error",
	// 					text: res.mensagem.descricao,
	// 					showConfirmButton: false,
	// 					timer: 5000,
	// 					timerProgressBar: true,
	// 				});
	// 				// this.router.navigate(['/procedimento-auditoria']);
	// 				return;
	// 			}
	// 		}
	//
	// 		this.form.patchValue(this.model);
	// 	} catch (err) {
	// 		Swal.fire({
	// 			toast: true,
	// 			position: "top-end",
	// 			icon: "error",
	// 			text: err.mensagem.descricao,
	// 			showConfirmButton: false,
	// 			timer: 5000,
	// 			timerProgressBar: true,
	// 		});
	// 		// this.router.navigate(['/procedimento-auditoria']);
	// 	}
	// 	this.atribuirTitulo();
	// }

	async ngOnInit() {
		this.state();
		await this.buscarTecnicas();

		try {
			if (!this.novoRegistro && this.id) {
				this.model.id = this.id;
				const res = await this.procedimentoAuditoriaService.obterPorId(this.id);
				if (!res.sucesso) throw res.mensagem;

				this.model = res.dados;
				this.enriquecerTecnicas();
				this.tecnicaAuditoriaDataSource =
					new MatTableDataSource(this.model.procedimentoTecnicaAuditoria);
				this.tecnicaAuditoriaDataSource._updateChangeSubscription();
				this.semDados = this.tecnicaAuditoriaDataSource.filteredData.length === 0;
			}

			this.form.patchValue(this.model);
		} catch (e) {
			const mensagem = (e as any)?.descricao ?? e;
			this.exibirMensagemErro(mensagem);
		}

		this.atribuirTitulo();
	}

	ngAfterViewInit() {
		const editorElement = this.angularEditor?.textArea?.nativeElement;

		if (editorElement) {
			editorElement.addEventListener(
				"keydown",
				this.maxLengthAngularEditor.bind(this),
				false
			);

			editorElement.addEventListener("paste", (event: ClipboardEvent) => {
				event.preventDefault();

				const clipboardData = event.clipboardData || (window as any).clipboardData;
				const pastedText = clipboardData?.getData("text") || "";

				// Captura o texto atual visível, sem HTML
				const textoAtual = editorElement.innerText?.replace(/\s+/g, " ").trim() || "";
				const pastedLimpo = pastedText.replace(/\s+/g, " ").trim();

				const totalAtual = textoAtual.length;
				const restante = 1000 - totalAtual;

				if (restante > 0) {
					const textoPermitido = pastedLimpo.substring(0, restante);
					document.execCommand("insertText", false, textoPermitido);
				}
			});
		}
	}

	public maxLengthAngularEditor(e: KeyboardEvent) {
		const element = e.target as HTMLElement;
		const texto = element.innerText || ""; // Garante apenas o texto visível
		const max = 1000;

		const teclasPermitidas = [
			"Backspace",
			"Delete",
			"ArrowLeft",
			"ArrowRight",
			"ArrowUp",
			"ArrowDown",
			"Tab",
			"Control",
			"Meta",
			"Alt",
		];

		// Se ultrapassar o limite e não for uma tecla de controle, bloqueia
		if (texto.length >= max && !teclasPermitidas.includes(e.key)) {
			e.preventDefault();
		}
	}

	public async state() {
		// model questao
		this.modelQuestao = window.history.state.model;
		// model Subtipo Auditoria
		this.modelSubtipoAuditoria = window.history.state.modelSubtipoAuditoria;
		// model matriz planejamento
		this.modelMatrizPlanejamento =
			window.history.state.modelMatrizPlanejamento;
		// lista procedimento
		this.listaProcedimentoAuditoria =
			window.history.state.listaProcedimentoAuditoria;
		// lista questão
		this.listaQuestao = window.history.state.listaQuestao;
		// lista constatacao
		this.listaConstatacao = window.history.state.listaConstatacao;
		// lista Matriz Planejamento
		this.listaMatrizPlanejamento =
			window.history.state.listaMatrizPlanejamento;
		// rota
		if (window.history.state.rotaPrefixoSubtipoAuditoria) {
			this.rotaPrefixoSubtipoAuditoria =
				window.history.state.rotaPrefixoSubtipoAuditoria;
		}
		if (window.history.state.rotaPrefixoMatrizPlanejamento) {
			this.rotaPrefixoMatrizPlanejamento =
				window.history.state.rotaPrefixoMatrizPlanejamento;
		}
	}

	public verificarTamanho(e: any) {
		var regex = /(<([^>]+)>)/gi;
		var result = e.replace(regex, "");
		return result.length > 1000;
	}

	public async onSubmit(salvarEFechar: boolean = false) {
		this.salvar = true;

		if (this.verificarTamanho(this.form.controls["detalhamentoProcedimento"].value)) {
			Swal.fire({
				toast: true,
				position: "top-end",
				icon: "warning",
				text: "O campo Descrição não pode ter mais que 1000 caracteres",
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			});
			return;
		}

		if (this.form.invalid) {
			this.exibirMensagemAlerta("Formulário inválido");
			return;
		}

		this.atualizarModel(this.form.value);
		this.model.procedimentoTecnicaAuditoria = this.tecnicaAuditoriaDataSource.data;

		try {
			let res: IBaseModel<any> = null;

			if (this.novoRegistro) {
				// Inserir novo registro
				res = await this.procedimentoAuditoriaService.inserir(this.model);
				if (res.sucesso) {
					// Preserva o objeto retornado (inclui ativo=true) para que o
					// próximo "Salvar" (PUT) não inative o registro.
					this.model = res.dados;
					this.id = res.dados.id;
					this.novoRegistro = false; // passa a editar
					this.form.patchValue(this.model);
					this.atribuirTitulo();
				}
			} else {
				// Atualizar registro existente — garante o id da rota e
				// nunca envia ativo indefinido (inativaria o registro).
				this.model.id = this.model.id ?? this.id;
				if (this.model.ativo == null) this.model.ativo = true;
				res = await this.procedimentoAuditoriaService.atualizar(this.model);
			}

			if (res.sucesso) {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "success",
					text: "Registro salvo com sucesso!",
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});

				if (salvarEFechar) {
					// Se estiver dentro de modal, fecha retornando os dados
					if (this.isModal) {
						this.dialogRef.close({
							procedimentoAuditoriaId: this.model.id,
							procedimentoAuditoria: this.model,
						});
					} else {
						// Se não for modal, redireciona normalmente
						this.router.navigate(['/procedimento-auditoria']);
					}
				} else if (!this.isModal) {
					// Registro já inserido (novo ou edição): recarrega do banco para
					// refletir o persistido — sem isso o "Salvar" parecia não gravar.
					await this.recarregar();
					return;
				}
				// Em modal, mantém aberta para continuar edição
			} else {
				const validacoes = this.montarMensagensValidacao(res);
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "warning",
					text: validacoes,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			}
		} catch (err) {
			Swal.fire({
				toast: true,
				position: "top-end",
				icon: "error",
				text: err.mensagem?.descricao || 'Erro ao salvar registro',
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			});
		}
	}



	private async tratarSalvarEFechar() {
		if (this.modelQuestao && !this.isModal) {
			/* …redireciona para questão… */
		} else if (this.isModal) {
			const questaoId = this.dados?.model?.id ?? null;
			this.dialogRef.close({
				procedimentoAuditoriaId: this.model.id,
				procedimentoAuditoria: this.model,
				questaoId,
			});
		} else {
			this.router.navigate(["/procedimento-auditoria"]);
		}
	}

	public get nomeTecnicaSelecionada(): string {
		return (
			this.modelProcedimentoTecnicaAuditoria.tecnicaAuditoria?.nome ??
			this.nomeTecnicaPorId(
				this.modelProcedimentoTecnicaAuditoria.tecnicaAuditoriaId
			)
		);
	}

	public nomeTecnicaPorId(id: number): string {
		if (!id) return "";
		return this.listaTecnicas.find((t) => t.id === id)?.nome ?? "";
	}

	public async buscarTecnicas() {
		try {
			const res = await this.tecnicaAuditoriaService.obter("", true);
			if (res.sucesso)
				this.listaTecnicas = res.dados.filter((t) => t.ativo);
		} catch {
			this.listaTecnicas = [];
		}
	}

	private enriquecerTecnicas() {
		if (!this.model.procedimentoTecnicaAuditoria) return;
		this.model.procedimentoTecnicaAuditoria.forEach((item) => {
			if (!item.tecnicaAuditoria && item.tecnicaAuditoriaId) {
				item.tecnicaAuditoria = this.listaTecnicas.find(
					(t) => t.id === item.tecnicaAuditoriaId
				);
			}
		});
	}

	private async recarregar() {
		if (!this.model.id) return;
		try {
			const res = await this.procedimentoAuditoriaService.obterPorId(
				this.model.id
			);
			if (!res.sucesso) throw res.mensagem;
			this.model = res.dados;
			this.id = res.dados.id;
			this.novoRegistro = false;
			this.enriquecerTecnicas();
			this.tecnicaAuditoriaDataSource = new MatTableDataSource(
				this.model.procedimentoTecnicaAuditoria
			);
			this.tecnicaAuditoriaDataSource._updateChangeSubscription();
			this.semDados =
				this.tecnicaAuditoriaDataSource.filteredData.length === 0;
			this.form.patchValue(this.model);
			this.atribuirTitulo();
		} catch (e) {
			this.exibirMensagemErro((e as any)?.descricao ?? e);
		}
	}

	public incluirTecnicaAuditoria() {
		if (
			this.tecnicaAuditoriaDataSource.data.findIndex(
				(a) =>
					a.tecnicaAuditoriaId ===
					this.modelProcedimentoTecnicaAuditoria.tecnicaAuditoriaId
			) >= 0
		) {
			this.exibirMensagemAlerta(
				"Técnica de auditoria já cadastrado nesse procedimento"
			);
			return;
		}

		if (!this.modelProcedimentoTecnicaAuditoria.tecnicaAuditoria &&
			this.modelProcedimentoTecnicaAuditoria.tecnicaAuditoriaId) {
			this.modelProcedimentoTecnicaAuditoria.tecnicaAuditoria =
				this.listaTecnicas.find(
					(t) => t.id === this.modelProcedimentoTecnicaAuditoria.tecnicaAuditoriaId
				);
		}

		this.tecnicaAuditoriaDataSource.data.push(
			cloneDeep(this.modelProcedimentoTecnicaAuditoria)
		);
		this.tecnicaAuditoriaDataSource._updateChangeSubscription();
		this.modelProcedimentoTecnicaAuditoria =
			{} as IProcedimentoTecnicaAuditoriaModel;
		this.semDados = false;
	}

	public excluirTecnicaAuditoria(ind: number) {
		this.tecnicaAuditoriaDataSource.data.splice(ind, 1);
		this.tecnicaAuditoriaDataSource._updateChangeSubscription();
		this.semDados =
			this.tecnicaAuditoriaDataSource.filteredData.length === 0;
	}

	public async exibirModalTecnicaAuditoria() {
		try {
			const res = await this.tecnicaAuditoriaService.obter("", true);
			if (res.sucesso) {
				const dadosFiltrados = res.dados.filter(
					(tecnicaAuditoria) => tecnicaAuditoria.ativo
				);
				this.listaTecnicas = dadosFiltrados;
				const modal = this.exibirModal(
					"Selecionar Técnica de Auditoria",
					dadosFiltrados
				);
				modal.afterClosed().subscribe((data) => {
					if (data) {
						this.modelProcedimentoTecnicaAuditoria.tecnicaAuditoriaId =
							data.id;
						this.modelProcedimentoTecnicaAuditoria.tecnicaAuditoria =
							data;
					}
				});
			} else {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "error",
					text: res.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			}
		} catch (err) {
			Swal.fire({
				toast: true,
				position: "top-end",
				icon: "error",
				text: err.mensagem.descricao,
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			});
		}
	}

	private atualizarModel(values: any) {
		Object.assign(this.model, values);
	}

	public onBack() {
		if (this.isModal) {
			this.dialogRef.close();
			return;
		}
		if (this.modelQuestao) {
			this.router.navigate(["/questao/novo"], {
				state: {
					model: this.modelQuestao,
					modelMatrizPlanejamento: this.modelMatrizPlanejamento,
					modelSubtipoAuditoria: this.modelSubtipoAuditoria,
					listaProcedimentoAuditoria: this.listaProcedimentoAuditoria,
					listaConstatacao: this.listaConstatacao,
					listaQuestao: this.listaQuestao,
					listaMatrizPlanejamento: this.listaMatrizPlanejamento,
					rotaPrefixoSubtipoAuditoria:
						this.rotaPrefixoSubtipoAuditoria,
					rotaPrefixoMatrizPlanejamento:
						this.rotaPrefixoMatrizPlanejamento,
				},
			});
		} else {
			this.router.navigate(["/procedimento-auditoria"]);
		}
	}

	atribuirTitulo() {
		if (this.novoRegistro) {
			this.titulo = "Novo Procedimento";
		} else {
			this.titulo = "Editar Procedimento - " + this.model.nome;
		}
		if (this.visualizar) {
			this.titulo = "Visualizar Procedimento - " + this.model.nome;
		}
	}
}
